import {fromJS, List, Map} from 'immutable';

import {
  HIDE_BADGE_TOOL_TIP,
  LOAD_ALL_BADGES_FULFILLED,
  LOAD_ALL_BADGES_PENDING,
  LOAD_ALL_BADGES_REJECTED,
  SHOW_BADGE_TOOL_TIP,
} from '../../actions';

import {
  LOAD_SCHOOL_FULFILLED,
  LOAD_SCHOOL_PENDING,
  LOAD_SCHOOL_REJECTED,
} from '../../../sideNavigationTitle/actions';

const initialState = new Map({
  loading: false,
  allBadges: new List(),
  earnedBadges: new List(),
  showTooltip: new Map({
    'Harper': false,
    'Paco': false,
    'Amelia': false,
    'Philo': false,
    'Ruby': false,
    'Lamar': false,
  }),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_ALL_BADGES_PENDING:
      return state.set('loading', true);

    case LOAD_ALL_BADGES_FULFILLED:
      return state.withMutations(map =>
        map.set('loading', false)
          .set('allBadges', fromJS(action.payload.data)));

    case LOAD_ALL_BADGES_REJECTED:
      return state.set('loading', false);

    case LOAD_SCHOOL_FULFILLED:
      return state.withMutations(map => {
        let currentlyEarnedBadges = new List();
        if (action.payload.data && action.payload.data.currentSchoolYear) {
          currentlyEarnedBadges = fromJS(action.payload.data.currentSchoolYear.earnedBadges.map(b => b.id));
        }
        map.set('loading', false)
          .set('earnedBadges', currentlyEarnedBadges);
      });

    case LOAD_SCHOOL_REJECTED:
      return state.set('loading', false);

    case LOAD_SCHOOL_PENDING:
      return state.set('loading', true);

    case HIDE_BADGE_TOOL_TIP:
      return state.withMutations(map => {
        map.setIn(['showTooltip', action.payload.characterName], false);
      });

    case SHOW_BADGE_TOOL_TIP:
      return state.withMutations(map => {
        map.setIn(['showTooltip', action.payload.characterName], true);
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/sideNavigationBadges/reducers/pages/navigationBadges.js